module.exports = __webpack_public_path__ + "img/Error1.a828299b.svg";